const jsonSchema = [
  {
    type: 'group',
    fields: [
      {
        name: 'name',
        label: 'Name',
        type: 'text',
        showInList: true,
        required: true
      },
      {
        name: 'licenceKey',
        label: 'Licence Key',
        type: 'text',
        showInList: true,
        required: false
      }
    ]
  },
  {
    name: 'comments',
    label: 'Comments',
    type: 'textarea',
    showInList: false,
    required: false
  }
];

export default jsonSchema;
